import {createSelector} from '@reduxjs/toolkit';

import {AppState} from '../';
import {TargetState} from './target.reducer';

const targetState = (state: AppState): TargetState => state.target;

export const activeTestsSelector = createSelector(
  targetState,
  state => state?.activeTests
);

export const adobeScriptLoadedSelector = createSelector(
  targetState,
  state => state?.adobeScriptLoaded
);

export const allowNewTermsScreenSelector = createSelector(
  activeTestsSelector,
  tests => tests?.includes('allow-new-terms-screen')
);

export const allowBreadSDKOriginalGLBA = createSelector(
  activeTestsSelector,
  tests => tests?.includes('allow-bread-sdk-original-glba')
);

export const allowBreadSDKNoGLBA = createSelector(
  activeTestsSelector,
  tests => tests?.includes('allow-bread-sdk-no-glba')
);

export const allowBreadSDKNoPrescreen = createSelector(
  activeTestsSelector,
  tests => tests?.includes('allow-bread-sdk-no-prescreen')
);
